// root '../../../';

// dependencies
import { Child } from 'pym.js';
import * as d3 from 'd3';
import Swiper from 'swiper';
import Zion from './utils/Zion';
import { classify } from './utils/helpers';

import data from './data/data.json';

// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

let swiper;
const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

window.pymChild = new Child({ renderCallback: init, id: pkg.name });

window.onload = () => {
  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);
      if (node) node.innerHTML = meta[id];
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

// function nationalityFlagEmoji(nationality) {
//   if (!nationality) return '';
//   const n = String(nationality).trim().toLowerCase();
//   if (n === 'usa' || n === 'united states' || n === 'american') return '🇺🇸';
//   if (n === 'mexico' || n === 'mexican') return '🇲🇽';
//   if (n === 'colombia' || n === 'colombian') return '🇨🇴';
//   return '';
// }

function sortByDeathDateDesc(rows) {
  const t = (s) => {
    if (!s) return 0;
    const ms = new Date(s).getTime();
    return Number.isNaN(ms) ? 0 : ms;
  };
  return [...rows].sort((a, b) => t(b['death-date']) - t(a['death-date']));
}

function equalizeCardHeights() {
  const cards = document.querySelectorAll('.swiper-slide .card');
  if (!cards.length) return;
  cards.forEach((el) => {
    el.style.minHeight = '';
  });
  let max = 0;
  cards.forEach((el) => {
    const h = el.getBoundingClientRect().height;
    if (h > max) max = h;
  });
  const px = `${Math.ceil(max)}px`;
  cards.forEach((el) => {
    el.style.minHeight = px;
  });
  if (window.pymChild) window.pymChild.sendHeight();
}

function populateSlider() {
  const rows = sortByDeathDateDesc(data);
  const swiperWrapper = d3.select('div.swiper-wrapper').html('');
  const slides = swiperWrapper.selectAll('.swiper-slide')
    .data(rows)
    .enter()
    .append('div')
    .attr('class', 'swiper-slide');

  const card = slides.append('div')
    .attr('class', 'card');

  const profile = card.append('div').attr('class', 'profile');

  const profileRow = profile.append('div').attr('class', 'profile-row');

  const photoWrap = profileRow.append('div').attr('class', 'profile-photo-wrap');

  photoWrap.append((d) => {
    const el = document.createElement(d.photo ? 'img' : 'div');
    if (d.photo && el.tagName === 'IMG') el.src = d.photo;
    return el;
  }).attr('class', 'profile-photo');

  const profileText = profileRow.append('div').attr('class', 'profile-text');

  profileText.append('p')
    .attr('class', 'profile-name')
    .html(d => d.name);

  profile.append('html')
    .attr('class', 'profile-blurb')
    .text(d => d.blurb || d.notes || '');

  // profileText.append('p')
  //   .attr('class', 'profile-text')
  //   .text(d => d.blurb || d.notes || '');

  card.append('p')
    .attr('class', 'card-age')
    .text((d) => {
      const a = d.age || '';
      // if (!a && !flag) return '';
      // const agePart = !a ? '' : (a === 'TK' ? 'TK' : `${a} years old`);
      // if (!agePart) return flag;
      return `Age: ${a}`;
    });


  // card.append('html')
  //   .attr('class', 'blurb')
  //   .text(d => d.blurb || d.notes || '');

  card.append('p')
    .attr('class', 'card-age')
    .text((d) => {
      const { nationality } = d;
      if (!nationality) return '';
      return `Nationality: ${nationality}`;
    });

  // card.append('p')
  //   .attr('class', 'card-age')
  //   .text((d) => {
  //     const { nationality } = d;
  //     const a = d.age || '';
  //     const agePart = !a ? '' : (a === 'TK' ? 'TK' : `${a} years old`);
  //     if (!agePart) return nationality;
  //     return nationality ? `${agePart} | ${nationality}` : agePart;
  //     if (!a && !nationality) return '';

  //     return `${nationality}`;
  //   });

  card.append('p')
    .attr('class', 'card-age')
    .text((d) => {
      const date = d['death-date'] || '';
      const place = d.location || '';
      if (!date && !place) return '';
      if (date && place) return `Died: ${date}, in ${place}`;
      if (date) return `Died: ${date}`;
      return place ? `Died: ${place}` : '';
    });


  card.append('br');

  card.append('p')
    .attr('class', 'dhs')
    .html(d => `${d.dhs}` || d.notes || '');

  document.querySelectorAll('.profile-photo').forEach((node) => {
    if (node.tagName === 'IMG' && !node.complete) {
      node.addEventListener('load', () => equalizeCardHeights(), { once: true });
    }
  });
}

function init() {
  populateSlider();

  swiper = new Swiper('.swiper', {
    direction: 'horizontal',
    cssMode: true,
    slidesPerView: 'auto',
    spaceBetween: 8,
    freeMode: {
      enabled: true,
    },
  });

  const swiperEl = document.querySelector('.swiper');
  const wrapperEl = document.querySelector('.swiper-wrapper');
  const runEqualize = () => requestAnimationFrame(equalizeCardHeights);

  if (wrapperEl) {
    const checkScrollEnd = () => {
      const atEnd = wrapperEl.scrollLeft + wrapperEl.clientWidth >= wrapperEl.scrollWidth - 2;
      swiperEl.classList.toggle('at-end', atEnd);
    };
    wrapperEl.addEventListener('scroll', checkScrollEnd);
    window.addEventListener('resize', () => {
      checkScrollEnd();
      runEqualize();
    });
    checkScrollEnd();
  } else {
    window.addEventListener('resize', runEqualize);
  }

  runEqualize();
  window.addEventListener('load', runEqualize);
}
